// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import * as MaintenanceNoteActions from '../actions/maintenance-note.actions';
import { MaintenanceNote } from '@fc-core';

export const maintenanceNoteFeatureKey = 'maintenanceNote';

export interface State {
  maintenanceNotes: MaintenanceNote[];
  noteError: any;
  loading: boolean;
}

export const initialState: State = {
  maintenanceNotes: [],
  noteError: null,
  loading: false,
};

export const reducer = createReducer(
  initialState,

  on(MaintenanceNoteActions.loadMaintenanceNotes, (state) => ({
    ...state,
    loading: true,
  })),
  on(MaintenanceNoteActions.loadMaintenanceNotesSuccess, (state, action) => ({
    ...state,
    maintenanceNotes: action.notes,
    loading: false,
  })),
  on(MaintenanceNoteActions.addMaintenanceNote, (state) => ({
    ...state,
    loading: true,
  })),
  on(MaintenanceNoteActions.addMaintenanceNoteSuccess, (state, action) => ({
    ...state,
    maintenanceNotes: [action.note, ...state.maintenanceNotes],
    loading: false,
  })),
  on(MaintenanceNoteActions.updateMaintenanceNote, (state) => ({
    ...state,
    loading: true,
  })),
  on(MaintenanceNoteActions.updateMaintenanceNoteSuccess, (state, action) => ({
    ...state,
    maintenanceNotes: [
      action.note,
      ...state.maintenanceNotes.filter((note) => note.id !== action.note.id),
    ],
    loading: false,
  })),
  on(MaintenanceNoteActions.maintenanceNotesError, (state, action) => ({
    ...state,
    noteError: action.err,
    loading: false,
  })),
  on(MaintenanceNoteActions.deleteMaintenanceNote, (state, action) => ({
    ...state,
    maintenanceNotes: state.maintenanceNotes.filter(
      (note) => note.id !== action.note.id,
    ),
  })),
  on(
    MaintenanceNoteActions.deleteMaintenanceNoteAttachmentSuccess,
    (state, action) => ({
      ...state,
      maintenanceNotes: state.maintenanceNotes.map((note) =>
        action.note.id === note.id
          ? {
              ...note,
              files: note.files.filter((file) => file.id !== action.file.id),
            }
          : note,
      ),
    }),
  ),
  on(
    MaintenanceNoteActions.deleteMaintenanceNoteAttachmentsSuccess,
    (state, action) => ({
      ...state,
      maintenanceNotes: state.maintenanceNotes.map((note) =>
        action.note.id === note.id
          ? {
              ...note,
              files: note.files.filter(
                (file) =>
                  !action.files.map((item) => item.id).includes(file.id),
              ),
            }
          : note,
      ),
    }),
  ),
);

export const getNotes = (state: State) => state.maintenanceNotes;
export const getNotesLoading = (state: State) => state.loading;
export const getNotesError = (state: State) => state.noteError;
